import { http } from '@/lib'
import { Label } from '@/types/api'

export type UpdateLabelsInput = Array<Partial<Label>>

export async function updateLabels(uuid: string, data: UpdateLabelsInput) {
  return http.put(`/${uuid}/labels`, data).then((response) => response.data)
}
